import React from 'react'

class RenderCount extends React.Component {
  count = 0

  constructor({ label, color }) {
    super()
  }

  render() {
    this.count++

    let style = {}
    if (this.props.color) {
      style.color = this.props.color
    }

    if (process.env.NODE_ENV === 'development') {
      // return this.count
      return (
        <span style={style}>{`${
          this.props.label ? this.props.label + ' ' : ''
        }${this.count}`}</span>
      )
    } else {
      return null
    }
  }
}

export default RenderCount
